import { jsx } from 'react/jsx-runtime';
import { useCardContext } from '../Card.context.esm.js';
import contentStyles from './CardContent.styles.esm.js';
import { cn } from '../../../utils/cn.esm.js';

const CardContent = ({ className, children }) => {
    const { imagePosition } = useCardContext();
    const styles = contentStyles({ imagePosition });
    return jsx("div", { className: cn(styles.content(), className), children: children });
};
CardContent.__CARD_CONTENT = true;
CardContent.displayName = "CardContent";

export { CardContent };
